import React from "react";
import ReactCountryFlag from "react-country-flag";
import type { FieldOption } from "../../types/components/dynamicForms";

const RenderCountryOption = (option: FieldOption): React.ReactNode => (
  <span className="bwp-country-option">
    <ReactCountryFlag
      countryCode={option.value}
      className="emojiFlag flag mr-8"
      style={{
        fontSize: "24px",
        lineHeight: "24px",
      }}
      aria-hidden
    />
    {option.label}
  </span>
);

export default RenderCountryOption;